import { Box } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { usePreviousState } from '@wix/rules-panel-ui';
import React, { useEffect } from 'react';
import { BiCtaNames } from '../../../../../../bi/types';
import { useA11yWizardAdapter } from '../../../../../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../../../../../hooks/use-bi-logger';
import { DrillInScreenHeader } from '../../drill-in-header/drill-in-screen-header';
import { useAltTextScreenContext } from '../alt-text-screen-wrapper';
import { AltTextOverviewSection } from './alt-text-overview-section';
export const AltTextScreenTopSection = () => {
  const biLogger = useBiLogger();
  const {
    t
  } = useTranslation();
  const {
    a11yWizardAdapter
  } = useA11yWizardAdapter();
  const {
    state: {
      filledAmount,
      shouldShowModalSaveBeforeClose,
      altRulesProps,
      isGeneratingAltTextSuggestions: isGenerating,
      pageName
    },
    actions: {
      navigateToPanel,
      setShouldShowSummary,
      getPaginationComponent,
      showBeforeCloseModal
    }
  } = useAltTextScreenContext();
  const prevIsGenerating = usePreviousState(isGenerating);
  useEffect(() => {
    if (prevIsGenerating && !isGenerating) {
      setShouldShowSummary(true);
    }
  }, [isGenerating, prevIsGenerating, setShouldShowSummary]);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    flex: "0 0 auto",
    zIndex: "10"
  }, /*#__PURE__*/React.createElement(DrillInScreenHeader, {
    title: t('accessibility-wizard.alt-text.header.title', {
      pageName
    }),
    onClickBack: () => {
      biLogger.taskCtaClick({
        ctaName: BiCtaNames.Back,
        elementCount: altRulesProps.length,
        failedElementCount: altRulesProps.length - filledAmount
      });
      biLogger.ctaClick({
        ctaName: BiCtaNames.Back
      });
      shouldShowModalSaveBeforeClose || isGenerating ? showBeforeCloseModal(navigateToPanel, isGenerating) : navigateToPanel();
    },
    onClickClose: () => {
      biLogger.taskCtaClick({
        ctaName: BiCtaNames.CloseTheWizard,
        elementCount: altRulesProps.length,
        failedElementCount: altRulesProps.length - filledAmount
      });
      shouldShowModalSaveBeforeClose || isGenerating ? showBeforeCloseModal(a11yWizardAdapter.togglePanel, isGenerating) : a11yWizardAdapter.togglePanel();
    }
  }), /*#__PURE__*/React.createElement(AltTextOverviewSection, {
    totalAmount: altRulesProps.length
  }), getPaginationComponent({
    isTopPagination: true
  }));
};
//# sourceMappingURL=alt-text-screen-top-section.js.map